const FooterView = () => import('./View')

export default function install(Vue) {
  Vue.component('footer-view', FooterView)
}
